import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareArrowTopRight2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-arrow-top-right-2, open, new, link, open link, box, arrow"} maskId="square-filled-radius-0-stroke-1-IconSquareArrowTopRight2"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H10V4H4V20H20V14H21V21H3V3ZM14 3H21V10H20V4.70711L11.5 13.2071L10.7929 12.5L19.2929 4H14V3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquareArrowTopRight2;
